import { useEffect, useState } from 'react';
import { collection, getDocs, limit, orderBy, query } from 'firebase/firestore';
import { db } from 'config/firebase';
import { useFirebaseAuth } from 'context/FirebaseAuthContext';
import { DECISIONS_COLLECTION } from '../config/rateShopConstants';
import { useRequestGuard } from './useRequestGuard';
export function useRecentRateShopDecisions() {
  const [user, authLoading] = useFirebaseAuth();
  const [decisions, setDecisions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const guard = useRequestGuard();
  useEffect(() => {
    const token = guard.begin();
    if (authLoading || !user) {
      setDecisions([]);
      setLoading(authLoading);
      return guard.invalidate;
    }
    setLoading(true);
    getDocs(
      query(
        collection(db, DECISIONS_COLLECTION),
        orderBy('decidedAt', 'desc'),
        limit(20)
      )
    )
      .then(snap => {
        if (guard.current(token)) {
          setDecisions(snap.docs.map(d => ({ id: d.id, ...d.data() })));
          setError(null);
        }
      })
      .catch(err => {
        if (guard.current(token)) setError(err);
      })
      .finally(() => {
        if (guard.current(token)) setLoading(false);
      });
    return guard.invalidate;
  }, [user, authLoading, guard]);
  return { decisions, loading, error };
}
